import { PageHeader } from "@/components/PageHeader/PageHeader";
import { Flex } from "antd";

import useTrackOnLoad from "@/hooks/useTrackPageview";
import ManageTeam from "@/pages/settings/ManageTeam";

function Settings() {
  useTrackOnLoad("Team viewed");

  return (
    <Flex
      vertical
      gap={12}
    >
      <PageHeader title="Team" />
      <ManageTeam />
    </Flex>
  );
}

export default Settings;
